export default __webpack_public_path__ + "static/media/sliders.ae0aef9b.svg";